import classNames from 'classnames'
import { useState } from 'react'
import { MdKeyboardArrowUp, MdKeyboardArrowDown, MdEdit } from 'react-icons/md'
import { Handle, Position } from 'reactflow'

import type { ReactElement } from 'react'
import type { NodeProps } from 'reactflow'
import type { ITodolistTemplateTask } from '~/types/todolist-template'

import Badge from '~/components/Badge'

import './styles.scss'

const REGEX =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm

type THandlers = {
  isEditable?: boolean
  onDelete: (task: ITodolistTemplateTask) => void
  onEdit: (task: ITodolistTemplateTask) => void
}

const TodolistTemplateTaskCard = ({ data }: NodeProps<ITodolistTemplateTask & THandlers>): ReactElement => {
  /** Local state */

  const [isCollapsed, setIsCollapsed] = useState(true)

  const formattedDescription = data.description.split(' ').map((word) => {
    return word.match(REGEX) ? (
      <>
        <a className="inner-link" href={word} rel="noreferrer" target="_blank">
          {word}
        </a>{' '}
      </>
    ) : (
      word + ' '
    )
  })

  /** Handlers */

  const handleEdit = () => data.onEdit(data)

  const handleDelete = () => data.onDelete(data)

  /** Render */

  return (
    <div className="todolist-template-task-card-component">
      <Handle position={Position.Top} type="target" />
      {data.isEditable ? (
        <>
          <button className="delete-button" onClick={handleDelete}>
            ×
          </button>
          <button className="edit-button" onClick={handleEdit}>
            <MdEdit size={12} />
          </button>
        </>
      ) : null}
      <div className="card-wrapper">
        <div className="card-header">
          <div className="title-container">
            <div className="title-content">
              <div className="card-header-title">{data.title}</div>
              {formattedDescription ? (
                <div
                  className={classNames('card-header-subtitle', {
                    'card-header-subtitle--collapsed': isCollapsed,
                  })}
                >
                  {formattedDescription}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="card-main-content">
          {data.group_names.length
            ? data.group_names.map((group) => <Badge className="badge" key={group} value={group} />)
            : null}
        </div>
        <div className="collapsed-button" onClick={() => setIsCollapsed((prev) => !prev)}>
          {isCollapsed ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />}
        </div>
      </div>
      <Handle id={data.template_task_id} position={Position.Bottom} type="source" />
    </div>
  )
}

export default TodolistTemplateTaskCard
